<template>
    <div class="dms-home-icon">
        <i class="fa-solid fa-layer-group"></i>
    </div>
</template>

<script>
export default {
    props: {
        context: {
            type: Object
        }
    }
}
</script>

<style scoped>
.dms-home-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 18px;
    background: linear-gradient(135deg, #667eea, #8b5cf6);
    font-size: 24px;
    color: #fff;
}
</style>

<script>
export default {
    props: {
        context: {
            type: Object
        }
    }
}
</script>